import {
  DELETE_PROCUREMENT_FAILURE,
  DELETE_PROCUREMENT_REQUEST,
  DELETE_PROCUREMENT_SUCCESS,
  GET_ALL_PROCUREMENT_LIST_FAILURE,
  GET_ALL_PROCUREMENT_LIST_REQUEST,
  GET_ALL_PROCUREMENT_LIST_SUCCESS,
  POST_PROCUREMENT_FAILURE,
  POST_PROCUREMENT_REQUEST,
  POST_PROCUREMENT_SUCCESS,
  PUT_PROCUREMENT_FAILURE,
  PUT_PROCUREMENT_REQUEST,
  PUT_PROCUREMENT_SUCCESS,
} from "../../../Utils/Constant";

// Get All Department List Details
export const getAllProcurementListRequest = (payload) => {
  return {
    type: GET_ALL_PROCUREMENT_LIST_REQUEST,
    payload,
  };
};

export const getAllProcurementListSuccess = (data) => {
  return {
    type: GET_ALL_PROCUREMENT_LIST_SUCCESS,
    payload: data,
  };
};

export const getAllProcurementListFailure = (error) => {
  return {
    type: GET_ALL_PROCUREMENT_LIST_FAILURE,
    payload: error,
  };
};

export const addProcurementRequest = (payload) => {
  return {
    type: POST_PROCUREMENT_REQUEST,
    payload,
  };
};

export const addProcurementSuccess = (data) => {
  return {
    type: POST_PROCUREMENT_SUCCESS,
    payload: data,
  };
};

export const addProcurementFailure = (error) => {
  return {
    type: POST_PROCUREMENT_FAILURE,
    payload: error,
  };
};

export const updateProcurementRequest = (payload) => {
  return {
    type: PUT_PROCUREMENT_REQUEST,
    payload,
  };
};

export const updateProcurementSuccess = (data) => {
  return {
    type: PUT_PROCUREMENT_SUCCESS,
    payload: data,
  };
};

export const updateProcurementFailure = (error) => {
  return {
    type: PUT_PROCUREMENT_FAILURE,
    payload: error,
  };
};

export const deleteProcurementRequest = (payload) => {
  return {
    type: DELETE_PROCUREMENT_REQUEST,
    payload,
  };
};

export const deleteProcurementSuccess = (data) => {
  return {
    type: DELETE_PROCUREMENT_SUCCESS,
    payload: data,
  };
};

export const deleteProcurementFailure = (error) => {
  return {
    type: DELETE_PROCUREMENT_FAILURE,
    payload: error,
  };
};